import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

// Note: to resolve
// group title in component
// group label from design

// No placeholder for option groups?

const OptionGroup = ({
  children,
  title,
  id,
  qaId,
}) => {
  return (
    <div
      className="uni-select__group"
      id={id}
      data-qa-id={qaId}
    >
      <h4 className="uni-select__group-label">
        {title}
      </h4>

      <ul className="uni-select__group-items">
        {children}
      </ul>
    </div>
  );
};

OptionGroup.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  id: PropTypes.string,
  qaId: PropTypes.string,
};

export default OptionGroup;



// WEBPACK FOOTER //
// ./src/selects/__partials/option-group/index.jsx